import { spawn } from "redux-saga/effects";
import watchApiGetDataSaga from './sagas/apiDataSaga'
import watchLoginSaga from './sagas/loginSaga'
 
export default function* rootSaga() {
  yield spawn(watchApiGetDataSaga);
  yield spawn(watchLoginSaga);
}

